export default "__VITE_ASSET__V9zt3buE__"